import { render } from "./EditableTable.vue?vue&type=template&id=70bdbb7e&scoped=true&ts=true"
import script from "./EditableTable.vue?vue&type=script&lang=ts"
export * from "./EditableTable.vue?vue&type=script&lang=ts"

import "./EditableTable.vue?vue&type=style&index=0&id=70bdbb7e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bdbb7e"]])

export default __exports__